  
 

  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>link</mat-icon></span>
     Add URL     
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>    
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Success Url</mat-label>
      <input matInput (input)="onSuccessURLChange($event.target.value)"
      placeholder="Add success url" [(ngModel)]="successUrl"/>
      <!-- <mat-error
      *ngIf="formDialog.get('successurl').invalid &&
             (formDialog.get('successurl').dirty ||
             formDialog.get('successurl').touched)">
      <span>This field is mandatory.</span>
    </mat-error> -->
  </mat-form-field>

  <div *ngIf="showSuccessUrlMessage==true" style="color: red;">Invalid URL</div>

  <mat-form-field class="example-full-width">
    <mat-label>Decline Url</mat-label>
    <input matInput (input)="onDeclineURLChange($event.target.value)"
    placeholder="Add decline url" [(ngModel)]="declineUrl"/>
    <!-- <mat-error
    *ngIf="formDialog.get('successurl').invalid &&
           (formDialog.get('successurl').dirty ||
           formDialog.get('successurl').touched)">
    <span>This field is mandatory.</span>
  </mat-error> -->
</mat-form-field>

<div *ngIf="showDeclineUrlMessage==true" style="color: red;">Invalid URL</div>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"  [disabled]="successUrl=='' && declineUrl=='' " 
  (click)="addUpdateFolderUrl()">Add
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>









